export default (values, value, type) => String(value).trim().length > 0;
